import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@material-ui/core/Grid';
import './faq-main.css';
import d1 from '../img/d1.png';
import d2 from '../img/d2.png';
import d3 from '../img/d3.png';
import d4 from '../img/d4.png';
import d21 from '../img/d21.png';
import d22 from '../img/d22.png';
import d23 from '../img/d23.png';
import d24 from '../img/d24.png';
import d31 from '../img/d31.png';
import d32 from '../img/d32.png';
import d33 from '../img/d33.png';
import d34 from '../img/d34.png';
import d41 from '../img/d41.png';
import d42 from '../img/d42.png';
import d43 from '../img/d43.png';
import d44 from '../img/d44.png';
import d51 from '../img/d51.png';
import d52 from '../img/d52.png';
import d53 from '../img/d53.png';
import d54 from '../img/d54.png';




export default function ControlledAccordions() {
  
  const [expanded, setExpanded] = React.useState('panel1');
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className='boxTabledropDown'>
      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} className="Box-Table">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className='headDropTableBox'
        >
          <Typography sx={{ width: '72%', flexShrink: 0 }} className="headDropTable">
            STAGE 1 - PRESALE
          </Typography>
          <Typography className='numberTable'>$225,000/$225,000</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          <div className='gridBoxTable'>
           <Grid container spacing={2}>
             <Grid item xs={3} md={3} sm={3}>
                 <img className='d' src={d1} />
             </Grid>
             <Grid item xs={3} md={3} sm={3}>
             <img className='d' src={d2} />
             </Grid>
             <Grid item xs={3} md={3} sm={3}>
             <img className='d' src={d3} />
             </Grid>
             <Grid item xs={3} md={3} sm={3}>
             <img className='d' src={d4} />
             </Grid>
           </Grid>      
           </div>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')} className="Box-Table">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='headDropTableBox2'
        >
          <Typography sx={{ width: '78%', flexShrink: 0 }} className="headDropTable">
          STAGE 2 - GENESIS COMMUNIIY SALE
          </Typography>
          <Typography className='numberTable'>
          $0/$1,255,000
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          <div className='gridBoxTable'>
           <Grid container spacing={2}>
             <Grid item xs={3} md={3} sm={3}>
                 <img className='d' src={d31} />
             </Grid>
             <Grid item xs={3} md={3} sm={3}>
             <img className='d' src={d32} />
             </Grid>
             <Grid item xs={3} md={3} sm={3}>
             <img className='d' src={d33} />
             </Grid>
             <Grid item xs={3} md={3} sm={3}>
             <img className='d' src={d34} />
             </Grid>
           </Grid>      
           </div>
          </Typography>
        </AccordionDetails>
      </Accordion>


      <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')} className="Box-Table">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='headDropTableBox2'
        >
          <Typography sx={{ width: '78%', flexShrink: 0 }} className="headDropTable">STAGE 3 - SEED INVESTOR</Typography>
          <Typography className='numberTable'>
          $0/$1,000,000
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          <div className='gridBoxTable'>
           <Grid container spacing={2}>
             <Grid item xs={3} md={3} sm={3}>
                 <img className='d' src={d21} />
             </Grid>
             <Grid item xs={3} md={3} sm={3}>
             <img className='d' src={d22} />
             </Grid>
             <Grid item xs={3} md={3} sm={3}>
             <img className='d' src={d23} />
             </Grid>
             <Grid item xs={3} md={3} sm={3}>
             <img className='d' src={d24} />
             </Grid>
           </Grid>      
           </div>
          </Typography>
        </AccordionDetails>
      </Accordion>


      <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')} className="Box-Table">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='headDropTableBox2'
        >
          <Typography sx={{ width: '78%', flexShrink: 0 }} className="headDropTable">
          STAGE 4 - PUBLIC IDO
          </Typography>
          <Typography className='numberTable'>
          $0/$1,000,000
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          <div className='gridBoxTable'>
           <Grid container spacing={2}>
             <Grid item xs={3} md={3} sm={3}>
                 <img className='d' src={d41} />
             </Grid>
             <Grid item xs={3} md={3} sm={3}>
             <img className='d' src={d42} />
             </Grid>
             <Grid item xs={3} md={3} sm={3}>
             <img className='d' src={d43} />
             </Grid>
             <Grid item xs={3} md={3} sm={3}>
             <img className='d' src={d44} />
             </Grid>
           </Grid>      
           </div>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')} className="Box-Table">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel5bh-content"
          id="panel5bh-header"
          className='headDropTableBox2'
        >
          <Typography sx={{ width: '78%', flexShrink: 0 }} className="headDropTable">
          STAGE 5 - CEX LISTING
          </Typography>
          <Typography className='numberTable'>
          $0/$2,000,000
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          <div className='gridBoxTable'>
           <Grid container spacing={2}>
             <Grid item xs={3} md={3} sm={3}>
                 <img className='d' src={d51} />
             </Grid>
             <Grid item xs={3} md={3} sm={3}>
             <img className='d' src={d52} />
             </Grid>
             <Grid item xs={3} md={3} sm={3}>
             <img className='d' src={d53} />
             </Grid>
             <Grid item xs={3} md={3} sm={3}>
             <img className='d' src={d54} />
             </Grid>
           </Grid>      
           </div>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
